import { formatDate } from '@angular/common';

export const DEFAULT_PLOT_VERSION = 1;
export const PLOT_HISTORY_LIST_MAX_CODES = 100;

export function currentVersionFromListItem(
  version: number | null | undefined
): number {
  return version != null && version >= 1 ? version : DEFAULT_PLOT_VERSION;
}

export function plotReviewKey(plantationCode: string, version: number): string {
  return `${plantationCode}::${version}`;
}

export function chunkPlotCodes(
  codes: string[],
  size = PLOT_HISTORY_LIST_MAX_CODES
): string[][] {
  const chunks: string[][] = [];
  for (let i = 0; i < codes.length; i += size) {
    chunks.push(codes.slice(i, i + size));
  }
  return chunks;
}

export function formatPlotReviewWhen(iso?: string | null): string {
  if (!iso) {
    return '';
  }

  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return formatDate(date, 'dd/MM/yyyy, HH:mm', 'en-US');
}
